export { default } from "./ScopesQuery";



// WEBPACK FOOTER //
// ./src/queries/ScopesQuery/index.ts